module.exports = __webpack_public_path__ + "static/vibhav-e39a22febf2873a3c83e97a014f7c8c8.png";